import './enter_phonenumber.less';

import React, { Proptypes } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link, browserHistory} from 'react-router';
import ResponsiveHeader from '../header/responsive_header';
import MediaQuery from 'react-responsive';
import ReactTelephoneInput from 'react-telephone-input';
import authActions from './auth_actions';
import ShowError from '../components/error/show_error';
import {routerActions} from 'react-router-redux';
import classNames from 'classnames';
import profileActions from '../profile/profile_actions';
import CONSTANTS from '../common_constants';
import validate from '../util/validate';

class EnterPhoneNumber extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      error: ''
    };
    this.phoneNumberAuthentication = this.phoneNumberAuthentication.bind(this);
    this.handlePhoneNoChange = this.handlePhoneNoChange.bind(this);
  }
  componentDidMount(){
    if(!this.props.location.query.isPhoneUpdate && validate.isEmpty(this.props.authState)){
      browserHistory.push('/signup')
    }
    this.setState({
      isFbAccountKitLoaded : true
    })

    // let interval =   setInterval(()=>{
    //   if(AccountKit.login)
    //   {
    //       clearInterval(interval);
    //       this.setState({
    //         isFbAccountKitLoaded: true
    //       })
    //   }
    //   else{
    //       AccountKit_OnInteractive = function(){
    //         AccountKit.init(
    //           {
    //             appId: '1261841187208489',
    //             state:"csrf123",
    //             version:"v1.1"
    //           }
    //         );
    //         this.setState({
    //           isFbAccountKitLoaded: false
    //         })
    //     }
    //   }
    // }, 1000);
  }
  handlePhoneNoChange(phoneNo, selectedCountry) {

    const phoneNumber = phoneNo.replace(/[-()+]/g,'');
    const countryCode ="+"+selectedCountry.dialCode;
    const formattedPhoneNo = phoneNumber.replace(selectedCountry.dialCode,'').replace(/\s/g,"");

    this.setState({
      phoneNo: formattedPhoneNo,
      countryCode
    });
  }

  accounKitLogin = (countryCode,phoneNo) => {
    const self = this;

    try{
      AccountKit.login(
        'PHONE',
        {countryCode: countryCode, phoneNumber: phoneNo},
        (response) => {

          const {props} = self;
          const {authState} = props;
          const {userData,signup,signin} = authState;

          if (response.status === "PARTIALLY_AUTHENTICATED") {
            if(userData && userData.email) amplitude.getInstance().setUserId(userData.email);
            amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.PHONE_VERFICATION_NUMBER_ENTRY);

            this.setState({fbAuthCode: response.code});

            let userId = '', interimSessionToken;

            if(userData && userData.userId) userId = userData.userId;
            if(userData && userData.encryptedId) userId = userData.encryptedId;

            if(signup && signup.errorData && signup.errorData.userId) userId = signup.errorData.userId;
            if(signin && signin.errorData && signin.errorData.userId) userId = signin.errorData.userId;

            if(signup && signup.errorData && signup.errorData.encryptedId) userId = signup.errorData.encryptedId;
            if(signin && signin.errorData && signin.errorData.encryptedId) userId = signin.errorData.encryptedId;

            if(userData && userData.interimSessionToken) interimSessionToken = userData.interimSessionToken;
            if(signup && signup.errorData && signup.errorData.interimSessionToken) interimSessionToken = signup.errorData.interimSessionToken;
            if(signin && signin.errorData && signin.errorData.interimSessionToken) interimSessionToken = signin.errorData.interimSessionToken;

            if(props.location.query.isPhoneUpdate){
              const parameters = {
                name : userData.name,
                email: userData.email,
                phoneNumber : countryCode + phoneNo,
                webPhoneNumber : phoneNo,
                webCountryCode : countryCode,
                accessToken: response.code
              }
              props.profileActions.updateProfile(parameters).then(() => {
                  browserHistory.push('/account');
              }, (errorRes) => {
                  this.setState({error: errorRes.error});
              })
            }else{
              const paramObj = {
                phoneNumber: countryCode + phoneNo,
                countryCode: countryCode,
                phoneNumberWithoutCountryCode: phoneNo,
                accessToken: response.code,
                userId,
                deviceTypeId: 3,
                deviceId:"12345"
              };

              props.actions.registerPhoneNumber(paramObj, interimSessionToken).then((data)=>{
                if(data.email) amplitude.getInstance().setUserId(data.email);
                amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.PHONE_VERFICATION_COMPLETE);
                browserHistory.push('/dashboard?isFirstTime=true');
              }, (errorRes) => {
                this.setState({error : errorRes.responseJSON.error})
              });
            }
          }
          else {
            this.setState({error : "Authentication failure"});
          }
      });
  }

  catch(e){
      AccountKit_OnInteractive = function(){
        AccountKit.init(
          {
            appId: '1261841187208489',
            state:"csrf123",
            version:"v1.1"
          }
        );
      }
      self.accounKitLogin(countryCode,phoneNo);
    }
  }

  //Account kit login for phoneNumber validation
  phoneNumberAuthentication(e) {
    const self = this;
    e.preventDefault();
    const { state,props } = this;
    const { countryCode, phoneNo } = state;
    const {userData} = props.authState;

    if(this.state.countryCode == ""){
      this.setState({
        error : "Please enter a valid country code"
      })
      return;
    }
    if(this.state.phoneNo == ""){
      this.setState({
        error : "Please enter a valid phone number"
      })
      return;
    }

    this.setState({error : ""});
    if(userData && userData.email) amplitude.getInstance().setUserId(userData.email);
    amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.PHONE_VERFICATION_START);


    this.accounKitLogin(countryCode,phoneNo);
  }

  render(){
    const {state , props} = this;
    let btnComponent, isSessionValid = false;
    if('userData' in props.authState)
      isSessionValid  = props.authState.userData.sessionValid;
    const isPhoneUpdate = props.location.query.isPhoneUpdate ;

    let goTo;
    if(isSessionValid)
      goTo = "/account";
    else
      goTo = "/";

    return(
      <div className="enter-phoneno-page">
        <MediaQuery query='(max-width: 767px)'>
          <ResponsiveHeader
            logoImagePath = "../public/images/landing/logo_white_saffron.png"
            iconClassName = "user-auth-menu-icon  icon-three-bars"
            responsiveHeaderClassName = "user-auth-default-header" />
        </MediaQuery>
        <MediaQuery query='(min-width: 768px)'>
          <Link to = {goTo}><div className="awb-logo-wrp"></div> </Link>
        </MediaQuery>
        <div className="enter-phoneno-wrapper">
          <div className="enter-phoneno-form-wrap">
            {state.error && <ShowError errorMessage = {state.error} />}
            <h1 className={props.location.query.isPhoneUpdate? 'displayNone': 'page-header text-align-center'}>Enter your phone number</h1>
            <h1 className={props.location.query.isPhoneUpdate? 'page-header text-align-center': 'displayNone'}>Enter your new phone number</h1>
            {/* <p className="text-align-center confirm-phoneno-text">Enter the 6-digit enteration code sent to you at +1 746 746 5435. Code may take up to 5 minutes to arrive.</p> */}
            <p className="text-align-center enter-phoneno-text">Tap Next to get an SMS confirmation from Account Kit powered by Facebook. AWB uses this to help you sign in, but you don't need a Facebook account. Message and data rates may apply. <a href="https://www.accountkit.com" className="link learn-more" target="_blank">Learn more</a></p>
            <form className="enter-phoneno-form text-align-center" >
              <ReactTelephoneInput
                defaultCountry='us'
                initialValue = '+1'
                flagsImagePath = '../../public/images/signup/flags.png'
                onChange = {this.handlePhoneNoChange}
               />
              <button className = {state.isFbAccountKitLoaded ? "btn orange validate-phonono-btn" : "btn orange validate-phonono-btn disabled"} onClick={this.phoneNumberAuthentication} >Next</button>
              {/* <div className="resend-code-wrp">
                <img className = "resend-img" src="../../public/images/icons_png/resend icon.png" />
                <span className = "resend-code">Resend Code</span>
              </div> */}
            </form>
          </div>
        </div>
      </div>
    )
  }
}

//connect Login modal and signup modal with actions and state
const mapStateToProps = (state) => {
  return {
    authState : state.app.auth || {}
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(authActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch),
    profileActions: bindActionCreators(profileActions, dispatch)
  }
}

EnterPhoneNumber = connect(
  mapStateToProps,
  mapDispatchToProps
)(EnterPhoneNumber);

export default EnterPhoneNumber;



// WEBPACK FOOTER //
// app/auth/enter_phonenumber.jsx